import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface WellnessPopupData {
  studentName: string;
  className: string;
  date: Date;
  trigger_translation?: string | null;
  studentId?: string | number;
}

@Component({
  selector: 'app-wellness-popup',
  templateUrl: './wellness-popup.component.html',
  styleUrls: ['./wellness-popup.component.scss']
})
export class WellnessPopupComponent {
  @Input() notification: WellnessPopupData | null = null;
  @Input() showProfileButton = true;
  @Output() closed = new EventEmitter<void>();
  @Output() goToProfile = new EventEmitter<string | number | undefined>();

  onClose(): void {
    this.closed.emit();
  }

  onOverlayClick(): void {
    this.closed.emit();
  }

  onGoToProfile(): void {
    this.goToProfile.emit(this.notification?.studentId);
  }

  formatNotificationDate(date: Date): string {
    if (!date) return '';
    const day = date.getDate();
    const months = [
      'de enero', 'de febrero', 'de marzo', 'de abril', 'de mayo', 'de junio',
      'de julio', 'de agosto', 'de septiembre', 'de octubre', 'de noviembre', 'de diciembre'
    ];
    return `${day} ${months[date.getMonth()]}`;
  }
}